// Helpers de gestion du consentement Loi 25 — extraits de
// ConsentBanner.tsx pour respecter la règle react-refresh/only-export-components
// (un fichier de composant ne doit exporter que des composants).

import { updateConsent } from '@/lib/analytics/gtm';

const COOKIE_NAME = 'baralambic-consent';
const COOKIE_DAYS = 365; // ~13 mois max recommandé par Loi 25

/** Event custom déclenché pour ré-ouvrir le bandeau depuis la page
 *  politique de confidentialité (exigence Loi 25 : retrait du consent
 *  aussi facile que l'octroi). */
export const CONSENT_REOPEN_EVENT = 'baralambic:consent:reopen';

export function getConsentCookie(): 'granted' | 'denied' | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;
  const value = match.split('=')[1];
  return value === 'granted' || value === 'denied' ? value : null;
}

export function setConsentCookie(value: 'granted' | 'denied'): void {
  if (typeof document === 'undefined') return;
  const expires = new Date(Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
  document.cookie = [
    `${COOKIE_NAME}=${value}`,
    `expires=${expires.toUTCString()}`,
    'path=/',
    'SameSite=Lax',
    window.location.protocol === 'https:' ? 'Secure' : '',
  ]
    .filter(Boolean)
    .join('; ');
}

/**
 * Efface le cookie de consentement, réinitialise GTM en denied, et
 * dispatch l'event de ré-ouverture du bandeau. Appelé depuis la page
 * Politique de confidentialité. Exigence Loi 25.
 */
export function reopenConsentBanner(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  updateConsent('denied');
  window.dispatchEvent(new CustomEvent(CONSENT_REOPEN_EVENT));
}
